import styled from 'styled-components'
import {Container, media} from '@modifi/ui'

export const ContentContainer = styled(Container)`
  padding-top: 56px;
  padding-bottom: 32px;
  ${media.max.xs`
    padding-left: 10px;
    padding-right: 10px;
  `}
`
